import { RootState } from '../../../Redux/Index';

export const getPadDetails = (state: RootState) =>
  state.currentProject.padDetails;
